import { MoreHorizontal } from 'lucide-react';
import { useState, type ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ActionMenu({ children }: { children: ReactNode }) {
  const [anchor, setAnchor] = useState<DOMRect | null>(null);
  return (
    <div className="inline-block">
      <Button
        variant="ghost"
        size="sm"
        aria-label="More actions"
        onClick={(e) =>
          setAnchor(anchor ? null : e.currentTarget.getBoundingClientRect())
        }
      >
        <MoreHorizontal className="h-4 w-4" />
      </Button>
      {anchor && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setAnchor(null)} />
          <div
            className="fixed z-50 min-w-48 rounded-md border bg-background p-1 shadow-md"
            style={{
              top: anchor.bottom + 4,
              right: window.innerWidth - anchor.right,
            }}
            onClick={() => setAnchor(null)}
          >
            {children}
          </div>
        </>
      )}
    </div>
  );
}

interface ActionMenuItemProps {
  onClick: () => void;
  disabledReason?: string;
  destructive?: boolean;
  children: ReactNode;
}

export function ActionMenuItem({
  onClick,
  disabledReason,
  destructive,
  children,
}: ActionMenuItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!!disabledReason}
      title={disabledReason}
      className={cn(
        'block w-full rounded px-2 py-1.5 text-left text-sm hover:bg-muted disabled:cursor-not-allowed disabled:opacity-50',
        destructive && 'text-destructive'
      )}
    >
      {children}
    </button>
  );
}
